import React from 'react';

import corner10 from '@backrs_ui/grow-ui/src/assets/images/gpa-guide/corner-10.png';
import corner11 from '@backrs_ui/grow-ui/src/assets/images/gpa-guide/corner-11.png';
import corner12 from '@backrs_ui/grow-ui/src/assets/images/gpa-guide/corner-12.png';
import corner9 from '@backrs_ui/grow-ui/src/assets/images/gpa-guide/corner-9.png';
import type { GpaGuideFourYearFramework } from '@backrs_ui/grow-ui/src/pages/GpaGuide/content/types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const CORNER_BY_GRADE: Record<number, string> = {
  9: corner9,
  10: corner10,
  11: corner11,
  12: corner12,
};

type FourYearFrameworkSectionProps = Readonly<{
  content: GpaGuideFourYearFramework;
}>;

export const FourYearFrameworkSection: React.FC<FourYearFrameworkSectionProps> = ({ content }) => (
  <Box sx={gridSx}>
    {content.years.map((year) => (
      <Box key={year.id} sx={cardSx}>
        {CORNER_BY_GRADE[year.number] && (
          <Box
            component="img"
            src={CORNER_BY_GRADE[year.number]}
            alt={`${year.number}th grade`}
            sx={cornerImgSx}
          />
        )}
        <Typography variant="text-lg-semibold" sx={titleSx}>
          {year.title}
        </Typography>
        <Box component="ul" sx={listSx}>
          {year.points.map((point) => (
            <Typography key={point} component="li" variant="text-sm-regular" sx={pointSx}>
              {point}
            </Typography>
          ))}
        </Box>
      </Box>
    ))}
  </Box>
);

const gridSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: backrs.spacing['spacing-xl'],
  '@container (min-width: 720px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
});

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
  p: backrs.spacing['spacing-3xl'],
  border: `1px solid ${backrs.colors['Colors/Border/border-secondary']}`,
  borderRadius: backrs.radius['radius-xl'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  overflow: 'hidden',
});

const cornerImgSx: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  right: 0,
  width: '52px',
  height: '52px',
};

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const listSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
  pl: backrs.spacing['spacing-xl'],
  m: 0,
});

const pointSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
